import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './GenerateLinkModal.module.scss';
export const GenerateLinkModal = (param)=>{
    let { recipientsCount, dismissModal } = param;
    const { t: texts } = useLocaleKeys('components.agreementStudio.silentProposal');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'generate_link_confirm'
            },
            secondaryButton: {
                name: 'generate_link_cancel'
            }
        },
        testId: 'generate-link-modal',
        title: texts.shareByLink(),
        width: "800px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.generateModalContent,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.generateLinkDescription()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.pleaseNote()
                }),
                /*#__PURE__*/ _jsxs("ul", {
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.listItem,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                children: texts.statusChangeSent()
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.listItem,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                children: texts.clientReminders()
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.listItem,
                            children: /*#__PURE__*/ _jsx(Typography, {
                                children: texts.uniqueLink()
                            })
                        })
                    ]
                })
            ]
        }),
        onCloseButtonClick: ()=>dismissModal(false),
        secondaryButtonLabel: commonButtons.cancel(),
        secondaryButtonTestId: "generate-link-modal-cancel",
        onSecondaryButtonClick: ()=>dismissModal(false),
        primaryButtonLabel: texts.generateButton({
            count: recipientsCount
        }),
        primaryButtonTestId: "generate-link-modal-generate",
        onPrimaryButtonClick: ()=>{
            dismissModal(true);
        }
    });
};
